//import axios from 'axios';
import localforage from 'localforage'
import memoryDriver from 'localforage-memoryStorageDriver'
import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import {interceptorResponse, interceptorError} from '@/helpers/interceptorResponse';


class API {
  async configure(){
    //await localforage.defineDriver(memoryDriver)

    const forageStore = localforage.createInstance({
      driver: [
        localforage.INDEXEDDB,
        localforage.LOCALSTORAGE,
        memoryDriver._driver
      ],
      name: 'infohidro-cluster-res-forecasts'
    });

    const cache = setupCache({
      maxAge: 5 * 60 * 1000,
      store: forageStore
    });


    const api = axios.create({
      adapter: cache.adapter,
      baseURL: `${process.env.VUE_APP_API_BASE_REST_FORECASTS}`,
      timeout: 60000
    });

    api.interceptors.response.use(
      interceptorResponse,
      interceptorError
    );

    return api;
  }
}

export default API;
